import messages from '../../translations/fr-FR.json';

import { Locale } from './Locale';

export type TranslationMessagesId = keyof typeof messages;

export type TranslationMessages = Record<TranslationMessagesId, string>;

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace FormatjsIntl {
        interface Message {
            ids: TranslationMessagesId;
        }
        interface IntlConfig {
            locale: Locale;
        }
    }
}

export async function getIntlMessages(locale: Locale): Promise<TranslationMessages> {
    const exports = await import(`../../translations/${locale}.json`);
    return exports.default as TranslationMessages;
}
